import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../../shared.module';
import { OverlayPanelModule } from '../../../../components/overlay-panel/overlay-panel.module';
import { DirectionsComponent } from './directions.component';
import { MapboxModule } from '../../mapbox/mapbox.module';



@NgModule({
  declarations: [DirectionsComponent],
  imports: [
    SharedProviderModule,
    OverlayPanelModule,
    MapboxModule
  ],
  exports: [
    DirectionsComponent
  ],
})
export class DirectionsModule { }
